import Container from "@/components/common/Container";
import Title from "./common/Title";

 const RESULTS_AND_OUTCOME_DATA = [
  {
    title: "Enhanced User Experience",
    description:
      "The implementation of user-centric design principles resulted in a significant enhancement of the overall user experience. Users, including experienced traders like Don, reported higher satisfaction with the platform's intuitive interface and streamlined trading process",
  },
  {
    title: "Informed Decision-Making",
    description:
      "The provision of real-time market data, customizable watchlists, and educational resources empowered users to make well-informed trading decisions.",
  },
  {
    title: "Increased Trading Volume",
    description:
      "As a cumulative effect of the improved user experience, efficient trade execution, enhanced security, and educational resources, the platform experienced a noticeable increase in trading volume.",
  },
  {
    title: "Positive User Feedback",
    description:
      "Users expressed their satisfaction with the platform through positive feedback and reviews. The platform achieved heightened user satisfaction, efficient trade execution and increased trading activity,",
  },
];

const ResultsAndOutcome = () => {
  return (
    <Container className="py-20 xl:py-36 bg-gray-100">
      <Title
        textBlack
        customClass="pb-6 xl:pb-20"
        SubTitle="Results & Outcome"
      />
      <Container large>
        <div className="flex flex-col md:flex-row flex-wrap justify-between xl:px-24 gap-10 md:gap-0 xl:gap-12">
          {RESULTS_AND_OUTCOME_DATA.map((value, index) => (
            <div
              key={value.title}
              className="w-full md:w-6/12 lg:w-5/12 flex md:pb-16 lg:pb-0"
            >
              <h2 className="text-2xl xl:text-5xl font-bold text-silver mb-0 pr-4">
                <span className="font-jost">0{index + 1}</span>
              </h2>
              <div>
                <h4 className="text-xl xl:text-3xl font-bold text-black-pearl xl:pt-4 text-nowrap">
                  <span className="font-jost">{value.title}</span>
                </h4>
                <p className="text-lg md:text-base xl:text-lg font-normal text-black text-justify pt-2">
                  <span className="font-jost">{value.description}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Container>
  );
};

export default ResultsAndOutcome;
